import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {post} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {t} from "@lingui/macro";

const successKeys = [
    actions.PAYROLL_IMPORT_SUCCESS,
];
const errorKeys = [
    actions.PAYROLL_IMPORT_ERROR,
];

// Create payroll
function* importPayrollRequest() {
    yield takeEvery(actions.PAYROLL_IMPORT_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request, payrollVendor }) {
                switch (payrollVendor) {
                    case 'talenox':
                        yield call(post, '/payroll/talenox', request, context);
                        break;
                    case 'kakitangan':
                        yield call(post, '/payroll/kakitangan', request);
                        break;
                    case 'mysyarikat':
                        yield call(post, '/payroll/mysyarikat', request);
                        break;
                    case 'payroll_panda':
                    default:
                        yield call(post, '/payroll/payrollpanda', request, context);
                        break;
                }
                // const data = yield response.data;

                // OK
                yield put({
                    type: actions.PAYROLL_IMPORT_SUCCESS,
                    // payroll: data.payroll,
                });
            });
    });
}

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.PAYROLL_IMPORT_SUCCESS:
            return t`The payroll is imported.`;
        default:
            return null;
    }
};

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(importPayrollRequest),
    ]);
}
